import { fetch } from '@/utils/http'

export default {
  bulletproofsContractDetact: params =>
    fetch('post', '/cbaas-service/v1/bulletproofs/contractDetact', params),

  bulletproofsContractInstall: params =>
    fetch('post', '/cbaas-service/v1/bulletproofs/contractInstall', params),

  contractCompute: params =>
    fetch('post', '/cbaas-service/v1/bulletproofs/contractCompute', params), //调用合约计算存储

  contractQueryAndVerify: params =>
    fetch('post', '/cbaas-service/v1/bulletproofs/contractQueryAndVerify', params), //调用合约并验证proof有效性

  contractVerifyQuery: params =>
    fetch('post', '/cbaas-service/v1/bulletproofs/contractVerifyQuery', params), //调用合约查询验证结果

  genOpening: params => fetch('post', '/cbaas-service/v1/bulletproofs/genOpening', params), //生成Opening

  pedersenVerify: params => fetch('post', '/cbaas-service/v1/bulletproofs/pedersenVerify', params), //再链下用于校验

  prove: params => fetch('post', '/cbaas-service/v1/bulletproofs/prove', params), //对一个数

  proveVerify: params => fetch('post', '/cbaas-service/v1/bulletproofs/proveVerify', params), //对一个数

  proveMethod: params => fetch('post', '/cbaas-service/v1/bulletproofs/proveMethod', params) //进行计算，生成proof，进行验证
}
